var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"topnav__suggestion-link",attrs:{"href":_vm.links[_vm.currentLink]['learn_more__link']},domProps:{"innerHTML":_vm._s(_vm.currentTitle)}})}
var staticRenderFns = []

export { render, staticRenderFns }